// Collection of tex typesetting code
// fractionBuilder: builds a fraction
export default function fractionBuilder(num, den, displayStyle = false) {
    let displayText = '';
    if (displayStyle) {
        displayText = "\\displaystyle ";
    }
    return displayText + "\\frac{" + num + "}{" + den + "}";
}
